import { z } from 'zod/v3';
import { errorMap } from '../../../../common/utils';
import { AlgorithmTargetRuleValidFormDataSchema } from './AlgorithmTargetRuleValidFormDataSchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-target-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmTargetValidFormDataSchema = z.object({
  id: z.number(),
  algorithmId: z.number(),
  condition: z.string().optional(),
  description: z.string().optional(),
  sequenceNumber: z.number(),
  targetKey: z.string().nullable(),
  rules: z.array(
    AlgorithmTargetRuleValidFormDataSchema,
    errorMap(() => t('validation.rules.required')),
  ),
});
